var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
import qs from 'qs';
import { useNavigate, useLocation } from 'react-router-dom';
import { Box, Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import PageLayout from '../../atoms/PageLayout';
import OfferListSelect from '../../organisms/OfferListSelect';
import RoasterSelect from '../../organisms/RoasterSelect';
import TypicaStockOrderForm from './TypicaStockOrderForm';
import { useRequest } from '../../../hooks/requestHook';
import { offerList as offerListApi, roaster as roasterApi } from '../../../api';
var AdminTypicaStockOrderPage = function () {
    var navigate = useNavigate();
    var location = useLocation();
    var t = useTranslation().t;
    var _a = React.useState(), offerList = _a[0], setOfferList = _a[1];
    var _b = React.useState(), roaster = _b[0], setRoaster = _b[1];
    var getOfferList = useRequest(offerListApi.get);
    var getRoaster = useRequest(roasterApi.get);
    var params = qs.parse(location.search.slice(1));
    var roasterId = params.roasterId, offerListId = params.offerListId;
    React.useEffect(function () {
        var id = Number(roasterId);
        if (!id)
            return;
        var canceled = false;
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getRoaster(id.toString())];
                    case 1:
                        response = _a.sent();
                        if (canceled || !response)
                            return [2 /*return*/];
                        setRoaster(response);
                        return [2 /*return*/];
                }
            });
        }); })();
        return function () {
            canceled = true;
        };
    }, [roasterId, getRoaster]);
    React.useEffect(function () {
        var id = Number(offerListId);
        var rId = Number(roasterId);
        if (!id || !rId) {
            setOfferList(undefined);
            return;
        }
        var canceled = false;
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getOfferList({
                            id: id.toString(),
                            roaster_id: rId.toString(),
                            with_transport_to_warehouses: true,
                        })];
                    case 1:
                        response = _a.sent();
                        if (canceled || !response)
                            return [2 /*return*/];
                        setOfferList(response);
                        return [2 /*return*/];
                }
            });
        }); })();
        return function () {
            canceled = true;
        };
    }, [offerListId, roasterId, getOfferList]);
    var handleChangeOfferList = React.useCallback(function (nextOfferList) {
        if (!nextOfferList)
            return;
        var queryString = qs.stringify({
            offerListId: (nextOfferList === null || nextOfferList === void 0 ? void 0 : nextOfferList.id) || '',
            roasterId: roasterId,
        });
        var currentPath = "".concat(location.pathname).concat(location.search);
        var nextPath = "".concat(location.pathname, "?").concat(queryString);
        if (currentPath === nextPath)
            return;
        navigate(nextPath);
    }, [roasterId, navigate, location]);
    var handleChangeRoaster = React.useCallback(function (nextRoaster) {
        if (!nextRoaster)
            return;
        var currentPath = "".concat(location.pathname).concat(location.search);
        var queryString = qs.stringify({
            offerListId: offerListId,
            roasterId: nextRoaster === null || nextRoaster === void 0 ? void 0 : nextRoaster.id,
        });
        var nextPath = "".concat(location.pathname, "?").concat(queryString);
        if (currentPath === nextPath)
            return;
        navigate(nextPath);
    }, [offerListId, navigate, location]);
    return (React.createElement(PageLayout, { title: t('pages.adminNewTypicaStockOrder.title'), backLink: true },
        React.createElement(Grid, { container: true, spacing: 2 },
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(OfferListSelect, { query: {
                        q: { have_typica_stock_items: true },
                    }, value: offerList, onChange: handleChangeOfferList })),
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(RoasterSelect, { value: roaster, onChange: handleChangeRoaster }))),
        React.createElement(Box, { marginTop: 2 }, offerList && roaster && (React.createElement(TypicaStockOrderForm, { offerList: offerList, roaster: roaster })))));
};
export default AdminTypicaStockOrderPage;
